module.exports = __webpack_public_path__ + "assets/images/hotel-01.96b5b3dfb183f95db79265d3d34bf568.svg";